import React from 'react';
import { Button, Card, CardActions, CardHeader, Divider, FormControlLabel, Grid, Switch, Typography } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {},
  statsContainer: {
    display: 'flex'
  },
  statsItem: {
    padding: theme.spacing(1),
    flexGrow: 1,
    '&:first-of-type': {
      borderRight: `1px solid ${theme.palette.divider}`
    },
    width: 10
  },
  content: {
    padding: 0
  },
  date: {
    whiteSpace: 'nowrap'
  },
  actions: {
    justifyContent: 'flex-end'
  },
}));

function CustomerActivity({ className, GununOzeti, checked, changeChecked, today, setToday, todayDisabled, ...rest }) {
  const classes = useStyles();

  if (GununOzeti.length === undefined) {
    return null;
  }

  const getKonusmaYazma = () => {
    return <div></div>;
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={getKonusmaYazma()}
        title="İş Planı Özeti" />

      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            ÜSTLENİLMEMİŞ
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.Ustlenilmemis}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            ÜSTLENİLMİŞ
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.Ustlenilmis}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            YOLA ÇIKILDI
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.YolaCikildi}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            BAŞLANDI
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.Baslandi}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            BAYİ TALEP
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.BayiTalep}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            İNTERNET TALEP
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.InternetTalep}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            KAPALI
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.Kapali}
          </Typography>
        </div>
        <Divider />
        <div className={classes.statsItem}>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            TOPLAM
          </Typography>
          <Typography
            align="center"
            variant="h3"
          >
            {GununOzeti[0]?.ToplamIs}
          </Typography>
        </div>
        <Divider />
      </div>
      <Divider />
      <CardActions className={classes.actions}>
        <Grid container spacing={1} >
          <Grid item xs={4} align="left">
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  onChange={(e) => changeChecked(e.target.checked)}
                  color="primary"
                />
              }
              label="Liste"
            />
          </Grid>
          <Grid item xs={4} align="center">
          <FormControlLabel
              control={
                <Switch
                  checked={today === 1}
                  onChange={(e) =>setToday(e.target.checked ? 1 : 0)}
                  color="primary"
                  disabled={todayDisabled}
                />
              }
              label={today === 0 ? "Dün" : "Bugün"}
            />
            </Grid>
          <Grid item xs={4} align="right">
            <Button
              color="primary"
              component={RouterLink}
              size="small"
              to="/overview"
              variant="text"
            >
              DETAY
              <ArrowForwardIcon className={classes.arrowForwardIcon} />
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

CustomerActivity.propTypes = {
  className: PropTypes.string
};

export default CustomerActivity;
